/**
 * رجیستری آیکون‌های منو — به‌جای import * که همه ۲۰۰۰+ آیکون MUI (~3.5MB)
 * را داخل main bundle می‌کشید، فقط آیکون‌های استفاده‌شده صریح import می‌شوند.
 * کلیدها هم snake_case (base-menu) و هم PascalCase (منوی رانتایم دیتابیس) پشتیبانی می‌شوند.
 */
import React from 'react';
import {
  AccountBalance, AccountBalanceWallet, AccountTree, AdminPanelSettings,
  Assessment, Business, Calculate, CalendarToday, Cloud, CurrencyExchange,
  Dashboard, Description, FactCheck, Factory, Info, InsertDriveFile,
  Inventory, Inventory2, ListAlt, LocalAtm, Mail, ManageAccounts,
  Menu as MenuIcon, Notifications, Payment, People, PlaylistAdd,
  PlaylistAddCheck, PointOfSale, PrecisionManufacturing, QrCode, Receipt,
  ReceiptLong, Search, Sell, Send, Settings, ShoppingCart, TableView,
  Warehouse,
} from '@mui/icons-material';

const icons: Record<string, React.ComponentType> = {
  // snake_case (base-menu)
  account_balance: AccountBalance,
  account_balance_wallet: AccountBalanceWallet,
  account_tree: AccountTree,
  assessment: Assessment,
  business: Business,
  calculate: Calculate,
  calendar_today: CalendarToday,
  cloud: Cloud,
  currency_exchange: CurrencyExchange,
  dashboard: Dashboard,
  mail: Mail,
  manage_accounts: ManageAccounts,
  menu: MenuIcon,
  notifications: Notifications,
  payment: Payment,
  people: People,
  playlist_add: PlaylistAdd,
  playlist_add_check: PlaylistAddCheck,
  receipt: Receipt,
  receipt_long: ReceiptLong,
  search: Search,
  settings: Settings,

  // آیکون‌های منوی رانتایم دیتابیس که معادل snake_case ندارند
  info: Info,
  insert_drive_file: InsertDriveFile,
  local_atm: LocalAtm,
  description: Description,
  admin_panel_settings: AdminPanelSettings,

  // انبار / فروش / تولید
  warehouse: Warehouse,
  inventory: Inventory,
  inventory_2: Inventory2,
  point_of_sale: PointOfSale,
  shopping_cart: ShoppingCart,
  fact_check: FactCheck,
  list_alt: ListAlt,
  sell: Sell,
  factory: Factory,
  precision_manufacturing: PrecisionManufacturing,
  qr_code: QrCode,
  send: Send,
  table_view: TableView,
};

// افزودن کلیدهای PascalCase (نام آیکون‌ها در منوی رانتایم دیتابیس PascalCase است)
Object.entries(icons).forEach(([key, component]) => {
  // account_balance -> AccountBalance
  const pascal = key.split('_').map(part => part.charAt(0).toUpperCase() + part.slice(1)).join('');
  icons[pascal] = component;
});

export const menuIconRegistry: Record<string, React.ComponentType> = icons;
